import { env } from "@/next.config";
import httpUtils from "@/utils/httpUtils";

export async function requestEditAccess(data, config) {
    return httpUtils.post(`${env.API_VERSION}/vc-request-edit`, data, config);
}

export async function approveEditAccess(token) {
    return httpUtils.get(`${env.API_VERSION}/vc-request-edit/approve`, { params: { token } });
}